<template>
  <div>

    <TitlePage :title="$t('closures')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" @click="create()">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile>
      <v-row class="mt-0 pl-4 pr-4 align-center">

        <v-col cols="12" md="3" class="pt-2 pb-0">
          <SportsAutocompleteSingle @message="setSportId" :model="this.filter.sport_id"></SportsAutocompleteSingle>
        </v-col>

        <v-col cols="12" md="3" class="pt-2 pb-0">
          <v-select
              :items="this.field_list"
              item-text="name"
              item-value="_id"
              label="Campo"
              small-chips
              v-model="filter.field_id"
              deletable-chips
          ></v-select>
        </v-col>

      </v-row>
      <v-row class="mt-0 pl-4 pr-4 align-center">
        <v-col cols="12" md="12" class="pt-2 pb-2 text-right">
          <v-btn elevation="2" color="primary" small class="mr-2" @click="makeSearch(true)">
            <v-icon left>mdi-card-search</v-icon>
            {{ $t('search') }}
          </v-btn>
          <v-btn elevation="2" color="error" small class="mr-2" @click="resetFilter()">
            RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>


    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.fields="{ item }">
          {{getAllFields(item.fields)}}
        </template>

        <template v-slot:item.center="{ item }">
          {{getCenter(item.fields)}}
        </template>

        <template v-slot:item.date_start="{ item }">
          {{formatDateHuman(item.date_start)}}
        </template>

        <template v-slot:item.date_end="{ item }">
          {{formatDateHuman(item.date_end)}}
        </template>


        <template v-slot:item.time="{ item }">
          <template v-if="item.all_day">
            Giorno Intero
          </template>
          <template v-else>
            {{item.time_start}} - {{item.time_end}}
          </template>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id)" :title="$t('edit')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('edit') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmRemove(item._id)" :title="$t('delete')">
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>{{ $t('delete') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import SportsAutocompleteSingle from "@/components/admin/SportsAutocompleteSingle";

const exportService = require('@/services/export')

export default {
  name: 'Fields',
  components: {SportsAutocompleteSingle,ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      field_list : [],
      field_complete_list: [],
      pathCreate: `/closures/${this.$route.params.centerId}/create/`,
      pathEdit:  `/closures/${this.$route.params.centerId}/edit/`,
      search: '',
      selected: [],
      headers: [
        { text: this.$t('sportCenter'), align: 'start', value: 'center'},
        { text: this.$t('fields'), align: 'start', value: 'fields'},
        { text: this.$t('name'), align: 'start', value: 'name'},
        { text: this.$t('dateStart'), align: 'start', value: 'date_start'},
        { text: this.$t('dateEnd'), align: 'start', value: 'date_end'},
        { text: this.$t('timeSlots'), align: 'start', value: 'time'},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100]
    };
  },
  async created(){
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)

    if(this.$route.params.centerId && this.getUser.super_admin){
      this.filter.center_id = this.$route.params.centerId
    }else {
      delete this.filter.center_id
    }

    let fields = await this.getCompleteList({center_id:this.$route.params.centerId});
    for(let field of fields.results){
      if(field.active){
        this.field_complete_list.push(field)
        let sports = field.sports_info.map(item => item['name']).join(', ');
        this.field_list.push({name:field.name+' ('+sports+')', _id: field._id})
        this.field_list = this.field_list.sort((a, b) => {
          if (a['name'].toLowerCase() < b['name'].toLowerCase()) {
            return -1;
          }
          if (a['name'].toLowerCase() > b['name'].toLowerCase()) {
            return 1;
          }
          return 0;
        });
      }
    }

    await this.makeSearch()
  },
  computed: {
    ...mapGetters({
      'getFilter':'closures/getFilter',
      'getOptionsPagination':'closures/getOptionsPagination',
      'getUser':'user/getUser'
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getCompleteList': 'fields/getCompleteList',
      'getItems': 'closures/index',
      'updateItem':'closures/update',
      'deleteItem': 'closures/delete',
      'massiveDeleteItem': 'closures/massDelete',
      'setFilter': 'closures/setFilter',
      'setOptionsPagination': 'closures/setOptionsPagination',
    }),

    async resetFilter(){
      let filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      let results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    create(){
      this.$router.push(this.pathCreate)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async export(){
      let csv = await exportService.getCsv(this.headers, this.items)
      let encodedUri = encodeURI(csv);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },

    async removeHandler(mode){
      if(this.typeDelete === 'single'){
        await this.remove(mode)
      }else if(this.typeDelete === 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          let results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },


    async setSportId(sport){
      this.filter.sport_id = sport._id
    },
    async getNewPage(){
      await this.makeSearch();
    },
    calculatePagination(count, limit){

      let divide = (count / limit)
      let rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    formatDateHuman(my_date) {
      if(my_date){
        let date = new Date(my_date)
        return ('0' + date.getDate()).slice(-2)+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+date.getFullYear()
      }else {
        return ''
      }
    },

    getAllFields(fields_id) {
      if(fields_id){
        let name = []
        for(let field of fields_id){
          let check = this.field_list.find((el)=> el._id.toString() === field._id.toString())
          if(check){
            name.push(check.name)
          }
        }
        name = name.sort((a, b) => {
          if (a.toLowerCase() < b.toLowerCase()) {
            return -1;
          }
          if (a.toLowerCase() > b.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        return name.toString()
      }else {
        return ''
      }
    },
    getCenter(field_id) {
      if(field_id[0]._id){
        let check = this.field_complete_list.find((el)=> el._id.toString() === field_id[0]._id.toString())
        if(check){
          return check.center.name
        }

      }else {
        return ''
      }
    },
  },
  mounted() {

  },
}
</script>
